import { setDataType as setDataTypeDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type SetDataTypeProps = ApiMethodBase & {
    field: string;
    type: string;
};

export const setDataType = ({
    field,
    type,
    eventEmitter,
}: SetDataTypeProps) => {
    setDataTypeDiagram(field, type);
    eventEmitter.emit(Event.updateDataTransformation);
};
